module.exports = __webpack_public_path__ + "img/logo-sm-light.58947763.png";